import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createBartender,
  deleteEntraUser,
  generateBartenderTap,
  listEntraUsers,
  updateEntraUser,
  type CreateBartenderBody,
  type UpdateEntraUserBody,
} from '../api/client';

const BARTENDERS_QUERY_KEY = ['admin', 'entra-users', 'bartender'] as const;

export function useBartenders() {
  return useQuery({
    queryKey: BARTENDERS_QUERY_KEY,
    queryFn: () => listEntraUsers({ jobTitle: 'Bartender' }),
    staleTime: 30_000,
  });
}

export function useCreateBartender() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateBartenderBody) => createBartender(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: BARTENDERS_QUERY_KEY });
    },
  });
}

export function useUpdateBartender() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, body }: { userId: string; body: UpdateEntraUserBody }) =>
      updateEntraUser(userId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: BARTENDERS_QUERY_KEY });
    },
  });
}

export function useDeleteBartender() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => deleteEntraUser(userId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: BARTENDERS_QUERY_KEY });
    },
  });
}

export function useGenerateBartenderTap() {
  return useMutation({
    mutationFn: (userId: string) => generateBartenderTap(userId),
  });
}
